const keys = {
  PRAZO_PAGAMENTO: {
    key: 'PRAZO_PAGAMENTO',
    description: 'Forma de pagamento',
  },
  QUANTIDADE: {
    key: 'QUANTIDADE',
    description: 'Quantidade do produto.',
  },
  VALOR_TOTAL: {
    key: 'VALOR_TOTAL',
    description: 'Valor total do produto',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
